<template>
	<v-container grid-list-md>
		<v-card flat>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12>
						<v-subheader>
							<strong>
								<v-icon left>mdi-radar</v-icon>
								{{ $t("label.reservation_notification") }}
							</strong>
						</v-subheader>
					</v-flex>
					<v-flex xs12 md12>
						<v-expansion-panels focusable>
							<v-expansion-panel>
								<v-expansion-panel-header>
									{{ $t("label.admin") }}
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-list>
										<app-notification-setting-list-item
											:title="'Reservation is created'"
											:subtitle="'Notify admin when a new notification is created via mail, database or broadcast.'"
											v-model="
												item.reservation.admin_created
											"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Reservation is pending'"
											:subtitle="'Notify admin when a new notification is pending via mail, database or broadcast.'"
											v-model="
												item.reservation.admin_pending
											"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Reservation is cancelled'"
											:subtitle="'Notify admin when a new notification is cancelled via mail, database or broadcast.'"
											v-model="
												item.reservation.admin_cancelled
											"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Reservation is dined'"
											:subtitle="'Notify admin when a new notification is denied via mail, database or broadcast.'"
											v-model="
												item.reservation.admin_denied
											"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Reservation is confirmed'"
											:subtitle="'Notify admin when a new notification is confirmed via mail, database or broadcast.'"
											v-model="
												item.reservation.admin_confirmed
											"
										></app-notification-setting-list-item>

										<app-notification-setting-list-item
											:title="'Reservation is completed'"
											:subtitle="'Notify admin when a new notification is completed via mail, database or broadcast.'"
											v-model="
												item.reservation.admin_completed
											"
										></app-notification-setting-list-item>

										<app-notification-setting-list-item
											:title="'Reservation is no show'"
											:subtitle="'Notify admin when a new notification is no_show via mail, database or broadcast.'"
											v-model="
												item.reservation.admin_no_show
											"
										></app-notification-setting-list-item>
									</v-list>
								</v-expansion-panel-content>
							</v-expansion-panel>
							<v-expansion-panel>
								<v-expansion-panel-header>
									{{ $t("Tenant") }}
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-list>
										<app-notification-setting-list-item
											:title="'Reservation is created'"
											:subtitle="'Notify tenant when a new notification is created via mail, database or broadcast.'"
											v-model="
												item.reservation.tenant_created
											"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Reservation is pending'"
											:subtitle="'Notify tenant when a new notification is pending via mail, database or broadcast.'"
											v-model="
												item.reservation.tenant_pending
											"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Reservation is cancelled'"
											:subtitle="'Notify tenant when a new notification is cancelled via mail, database or broadcast.'"
											v-model="
												item.reservation
													.tenant_cancelled
											"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Reservation is dined'"
											:subtitle="'Notify tenant when a new notification is denied via mail, database or broadcast.'"
											v-model="
												item.reservation.tenant_denied
											"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Reservation is confirmed'"
											:subtitle="'Notify tenant when a new notification is confirmed via mail, database or broadcast.'"
											v-model="
												item.reservation
													.tenant_confirmed
											"
										></app-notification-setting-list-item>

										<app-notification-setting-list-item
											:title="'Reservation is completed'"
											:subtitle="'Notify tenant when a new notification is completed via mail, database or broadcast.'"
											v-model="
												item.reservation
													.tenant_completed
											"
										></app-notification-setting-list-item>

										<app-notification-setting-list-item
											:title="'Reservation is no show'"
											:subtitle="'Notify tenant when a new notification is no_show via mail, database or broadcast.'"
											v-model="
												item.reservation.tenant_no_show
											"
										></app-notification-setting-list-item>
									</v-list>
								</v-expansion-panel-content>
							</v-expansion-panel>
							<v-expansion-panel>
								<v-expansion-panel-header>
									{{ $t("Customer") }}
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-list>
										<app-notification-setting-list-item
											:title="'Reservation is created'"
											:subtitle="'Notify customer when a new notification is created via mail, database or broadcast.'"
											v-model="
												item.reservation
													.customer_created
											"
											firebase
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Reservation is pending'"
											:subtitle="'Notify customer when a new notification is pending via mail, database or broadcast.'"
											v-model="
												item.reservation
													.customer_pending
											"
											firebase
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Reservation is cancelled'"
											:subtitle="'Notify customer when a new notification is cancelled via mail, database or broadcast.'"
											v-model="
												item.reservation
													.customer_cancelled
											"
											firebase
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Reservation is dined'"
											:subtitle="'Notify customer when a new notification is denied via mail, database or broadcast.'"
											v-model="
												item.reservation.customer_denied
											"
											firebase
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Reservation is confirmed'"
											:subtitle="'Notify customer when a new notification is confirmed via mail, database or broadcast.'"
											v-model="
												item.reservation
													.customer_confirmed
											"
											firebase
										></app-notification-setting-list-item>

										<app-notification-setting-list-item
											:title="'Reservation is completed'"
											:subtitle="'Notify customer when a new notification is completed via mail, database or broadcast.'"
											v-model="
												item.reservation
													.customer_completed
											"
											firebase
										></app-notification-setting-list-item>

										<app-notification-setting-list-item
											:title="'Reservation is no show'"
											:subtitle="'Notify customer when a new notification is no_show via mail, database or broadcast.'"
											v-model="
												item.reservation
													.customer_no_show
											"
											firebase
										></app-notification-setting-list-item>
									</v-list>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
					</v-flex>
					<v-flex xs12>
						<v-subheader>
							<strong>
								<v-icon left>mdi-radar</v-icon>
								{{ $t("label.order_notification") }}
							</strong>
						</v-subheader>
					</v-flex>
					<v-flex xs12 md12>
						<v-expansion-panels focusable>
							<v-expansion-panel>
								<v-expansion-panel-header>
									{{ $t("label.admin") }}
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-list>
										<app-notification-setting-list-item
											:title="'Order is created'"
											:subtitle="'Notify admin when a new notification is created via mail, database or broadcast.'"
											v-model="item.order.admin_created"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is pending'"
											:subtitle="'Notify admin when a new notification is pending via mail, database or broadcast.'"
											v-model="item.order.admin_pending"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is accepted'"
											:subtitle="'Notify admin when a new notification is accepted via mail, database or broadcast.'"
											v-model="item.order.admin_accepted"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is preparing'"
											:subtitle="'Notify admin when a new notification is preparing via mail, database or broadcast.'"
											v-model="item.order.admin_preparing"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is prepared'"
											:subtitle="'Notify admin when a new notification is prepared via mail, database or broadcast.'"
											v-model="item.order.admin_prepared"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is processing'"
											:subtitle="'Notify admin when a new notification is processing via mail, database or broadcast.'"
											v-model="
												item.order.admin_processing
											"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is completed'"
											:subtitle="'Notify admin when a new notification is completed via mail, database or broadcast.'"
											v-model="item.order.admin_completed"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is cancelled'"
											:subtitle="'Notify admin when a new notification is cancelled via mail, database or broadcast.'"
											v-model="item.order.admin_cancelled"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is declined'"
											:subtitle="'Notify admin when a new notification is declined via mail, database or broadcast.'"
											v-model="item.order.admin_declined"
										></app-notification-setting-list-item>
									</v-list>
								</v-expansion-panel-content>
							</v-expansion-panel>
							<v-expansion-panel>
								<v-expansion-panel-header>
									{{ $t("Tenant") }}
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-list>
										<app-notification-setting-list-item
											:title="'Order is created'"
											:subtitle="'Notify tenant when a new notification is created via mail, database or broadcast.'"
											v-model="item.order.tenant_created"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is pending'"
											:subtitle="'Notify tenant when a new notification is pending via mail, database or broadcast.'"
											v-model="item.order.tenant_pending"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is accepted'"
											:subtitle="'Notify tenant when a new notification is accepted via mail, database or broadcast.'"
											v-model="item.order.tenant_accepted"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is preparing'"
											:subtitle="'Notify tenant when a new notification is preparing via mail, database or broadcast.'"
											v-model="
												item.order.tenant_preparing
											"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is prepared'"
											:subtitle="'Notify tenant when a new notification is prepared via mail, database or broadcast.'"
											v-model="item.order.tenant_prepared"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is processing'"
											:subtitle="'Notify tenant when a new notification is processing via mail, database or broadcast.'"
											v-model="
												item.order.tenant_processing
											"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is completed'"
											:subtitle="'Notify tenant when a new notification is completed via mail, database or broadcast.'"
											v-model="
												item.order.tenant_completed
											"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is cancelled'"
											:subtitle="'Notify tenant when a new notification is cancelled via mail, database or broadcast.'"
											v-model="
												item.order.tenant_cancelled
											"
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is declined'"
											:subtitle="'Notify tenant when a new notification is declined via mail, database or broadcast.'"
											v-model="item.order.tenant_declined"
										></app-notification-setting-list-item>
									</v-list>
								</v-expansion-panel-content>
							</v-expansion-panel>
							<v-expansion-panel>
								<v-expansion-panel-header>
									{{ $t("Customer") }}
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-list>
										<app-notification-setting-list-item
											:title="'Order is created'"
											:subtitle="'Notify customer when a new notification is created via mail, database or broadcast.'"
											v-model="
												item.order.customer_created
											"
											firebase
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is pending'"
											:subtitle="'Notify customer when a new notification is pending via mail, database or broadcast.'"
											v-model="
												item.order.customer_pending
											"
											firebase
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is accepted'"
											:subtitle="'Notify customer when a new notification is accepted via mail, database or broadcast.'"
											v-model="
												item.order.customer_accepted
											"
											firebase
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is preparing'"
											:subtitle="'Notify customer when a new notification is preparing via mail, database or broadcast.'"
											v-model="
												item.order.customer_preparing
											"
											firebase
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is prepared'"
											:subtitle="'Notify customer when a new notification is prepared via mail, database or broadcast.'"
											v-model="
												item.order.customer_prepared
											"
											firebase
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is processing'"
											:subtitle="'Notify customer when a new notification is processing via mail, database or broadcast.'"
											v-model="
												item.order.customer_processing
											"
											firebase
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is completed'"
											:subtitle="'Notify customer when a new notification is completed via mail, database or broadcast.'"
											v-model="
												item.order.customer_completed
											"
											firebase
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is cancelled'"
											:subtitle="'Notify customer when a new notification is cancelled via mail, database or broadcast.'"
											v-model="
												item.order.customer_cancelled
											"
											firebase
										></app-notification-setting-list-item>
										<app-notification-setting-list-item
											:title="'Order is declined'"
											:subtitle="'Notify customer when a new notification is declined via mail, database or broadcast.'"
											v-model="
												item.order.customer_declined
											"
											firebase
										></app-notification-setting-list-item>
									</v-list>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
					</v-flex>
				</v-layout>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					@click="submit()"
					color="primary"
					:loading="item.processing"
				>
					<v-icon left>mdi-content-save</v-icon>
					{{ $t("Save") }}</v-btn
				>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-container>
</template>

<script>
import CentralLayout from "../../../layouts/central.vue";
import CentralSettingLayout from "../../../layouts/partials/central/setting.vue";
export default {
	layout: [CentralLayout, CentralSettingLayout],

	props: ["data"],

	data() {
		return {
			item: this.$inertia.form(this.data),
		};
	},

	methods: {
		async submit() {
			try {
				this.item.post(
					this.$route("central.settings.store", {
						key: "notification",
					})
				);
			} catch (error) {
				this.$toast.error(error.message);
			}
		},
	},
};
</script>